module.exports = __webpack_public_path__ + "img/diy-UbJiSkMa.77ba52c7.svg";